import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import { YIELDS_BY_NAME_THIRTY_DAY } from '../../../utils/constants'
import { buildYieldWithNames } from '../../../utils/functions'
import AsOfDate from '../../AsOfDate'

import PriceTable from './components/PriceTable'
import YieldTable from './components/YieldTable'

const Container = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(9),
}))

const ContentContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2.5),
  padding: theme.spacing(1, 2, 2),
}))

const TitleContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(5),
}))

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '24px',
}))

export default function FundOverviewCurrentPrice({ data, popups }) {
  const asofdate = data?.price?.calendar?.date || null
  const yieldMappings = buildYieldWithNames(
    data?.yields,
    popups || [],
    YIELDS_BY_NAME_THIRTY_DAY
  )

  const [price] = useState(data?.price)
  const [yields] = useState(yieldMappings)

  return (
    <Container>
      <ContentContainer>
        <AsOfDate date={asofdate} />
        <Box>
          <PriceTable price={price} />
          {yields && yields.length > 0 && <YieldTable yields={yields} />}
        </Box>
      </ContentContainer>
    </Container>
  )
}

FundOverviewCurrentPrice.propTypes = {
  data: PropTypes.shape({
    price: PropTypes.shape({
      calendar: PropTypes.shape({
        date: PropTypes.string,
      }),
    }),
    yields: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  }),
  popups: PropTypes.array,
}
